// Contingut de la plantilla de l'Hotel Camprodon (disseny
// ~/Desktop/hotelcamprodon/web). Els textos genèrics (menú, botons,
// serveis...) són claus de les traduccions de la web (t(), Traducciones/
// lang/*.json); aquí només hi ha les rutes, l'estructura i els textos propis
// de l'hotel per idioma (TEXTOS). Imatges a public/images/web/hotelcamprodon/.

export const RUTA_IMATGES = "/images/web/hotelcamprodon/";

// Slug de cada pàgina interna per idioma (PaginasController::paginaHotelCamprodon,
// routes/web/web.php i resources/lang/{idioma}/routes.php). Els idiomes
// sense slug propi fan servir el castellà.
export const RUTAS = {
    "hotel": {
        "es": "hotel",
        "ca": "hotel",
        "en": "hotel",
        "fr": "hotel"
    },
    "habitaciones": {
        "es": "hotel/habitaciones",
        "ca": "hotel/habitacions",
        "en": "hotel/rooms",
        "fr": "hotel/chambres"
    },
    "servicios": {
        "es": "hotel/servicios",
        "ca": "hotel/serveis",
        "en": "hotel/services",
        "fr": "hotel/services"
    },
    "galeria": {
        "es": "hotel/galeria-imagenes",
        "ca": "hotel/galeria-imatges",
        "en": "hotel/image-gallery",
        "fr": "hotel/galerie-images"
    },
    "restaurante": {
        "es": "restaurante",
        "ca": "restaurant",
        "en": "restaurant",
        "fr": "restaurant"
    },
    "bar-albeniz": {
        "es": "bar-albeniz",
        "ca": "bar-albeniz",
        "en": "albeniz-bar",
        "fr": "bar-albeniz"
    },
    "eventos": {
        "es": "eventos",
        "ca": "esdeveniments",
        "en": "events",
        "fr": "evenements"
    },
    "bodas": {
        "es": "eventos/bodas",
        "ca": "esdeveniments/casaments",
        "en": "events/weddings",
        "fr": "evenements/mariages"
    },
    "empresas": {
        "es": "eventos/empresas",
        "ca": "esdeveniments/empreses",
        "en": "events/companies",
        "fr": "evenements/entreprises"
    },
    "grupos": {
        "es": "eventos/grupos-deportistas",
        "ca": "esdeveniments/grups-esportistes",
        "en": "events/groups-athletes",
        "fr": "evenements/groupes-athletes"
    },
    "que-hacer": {
        "es": "que-hacer-en-camprodon-girona",
        "ca": "que-fer-a-camprodon-girona",
        "en": "what-to-do-in-camprodon-spain",
        "fr": "que-faire-a-camprodon-espagne"
    },
    "camprodon": {
        "es": "que-hacer-en-camprodon-girona/camprodon",
        "ca": "que-fer-a-camprodon-girona/camprodon",
        "en": "what-to-do-in-camprodon-spain/camprodon",
        "fr": "que-faire-a-camprodon-espagne/camprodon"
    },
    "actividades": {
        "es": "que-hacer-en-camprodon-girona/actividades-en-camprodon",
        "ca": "que-fer-a-camprodon-girona/activitats-a-camprodon",
        "en": "what-to-do-in-camprodon-spain/activities-in-camprodon",
        "fr": "que-faire-a-camprodon-espagne/activites-a-camprodon"
    },
    "ofertas": {
        "es": "ofertas-hotel-camprodon-girona",
        "ca": "ofertes-hotel-camprodon-girona",
        "en": "hotel-deals-camprodon-spain",
        "fr": "offres-hotel-camprodon-espagne"
    },
    "oferta-2-noches": {
        "es": "ofertas-hotel-camprodon-girona/oferta-2-noches",
        "ca": "ofertes-hotel-camprodon-girona/oferta-2-nits",
        "en": "hotel-deals-camprodon-spain/offer-2-nights",
        "fr": "offres-hotel-camprodon-espagne/offre-2-nuits"
    },
    "newsletter": {
        "es": "newsletter",
        "ca": "newsletter",
        "en": "newsletter",
        "fr": "newsletter"
    }
};

export const rutaPagina = (pagina, lang) => {
    const idioma = (lang || "es").toString().toLowerCase();
    const slug = RUTAS[pagina][idioma] || RUTAS[pagina].es;
    return idioma === "es" ? "/" + slug : "/" + idioma + "/" + slug;
};

// Menú principal: `t` = clau de traducció; `href: "@reserva"` = cercador
// (buscar2).
export const MENU = [
    {
        "t": "Hotel",
        "pagina": "hotel",
        "sub": [
            {
                "t": "Habitaciones",
                "pagina": "habitaciones"
            },
            {
                "t": "Servicios",
                "pagina": "servicios"
            },
            {
                "t": "Galería",
                "pagina": "galeria"
            }
        ]
    },
    {
        "t": "Restaurante",
        "pagina": "restaurante",
        "sub": []
    },
    {
        "label": "Bar Albeniz",
        "pagina": "bar-albeniz",
        "sub": []
    },
    {
        "t": "Eventos",
        "pagina": "eventos",
        "sub": [
            {
                "t": "Bodas",
                "pagina": "bodas"
            },
            {
                "t": "Empresas",
                "pagina": "empresas"
            },
            {
                "t": "Grupos y deportistas",
                "pagina": "grupos"
            }
        ]
    },
    {
        "t": "Camprodón",
        "pagina": "que-hacer",
        "sub": [
            {
                "t": "Camprodón",
                "pagina": "camprodon"
            },
            {
                "t": "Actividades en Camprodón",
                "pagina": "actividades"
            }
        ]
    },
    {
        "t": "Ofertas",
        "pagina": "ofertas",
        "sub": [
            {
                "t": "Oferta 2 noches",
                "pagina": "oferta-2-noches"
            }
        ]
    },
    {
        "t": "Reserva",
        "href": "@reserva",
        "sub": []
    }
];

// Serveis de la portada (icones a public/images/web/hotelcamprodon/serveis/).
export const SERVICIOS = [
    {
        "icono": "wifi.svg",
        "nombre": "Wifi"
    },
    {
        "icono": "restaurant.svg",
        "nombre": "Restaurante"
    },
    {
        "icono": "piano-bar.svg",
        "nombre": "Piano bar"
    },
    {
        "icono": "parking.svg",
        "nombre": "Aparcamiento"
    },
    {
        "icono": "sportive-tourism.svg",
        "nombre": "Turismo deportivo"
    },
    {
        "icono": "family-hotel.svg",
        "nombre": "Hotel familiar"
    },
    {
        "icono": "24h-reception.svg",
        "nombre": "Recepción 24 horas"
    },
    {
        "icono": "bike-guard.svg",
        "nombre": "Guarda bicicletas"
    },
    {
        "icono": "business-center.svg",
        "nombre": "Centro de negocios"
    },
    {
        "icono": "conference-room.svg",
        "nombre": "Sala de conferencias"
    },
    {
        "icono": "connected-rooms.svg",
        "nombre": "Habitaciones comunicadas"
    },
    {
        "icono": "exterior-parking.svg",
        "nombre": "Aparcamiento exterior"
    },
    {
        "icono": "games-room.svg",
        "nombre": "Sala de juegos"
    },
    {
        "icono": "garden.svg",
        "nombre": "Jardín"
    },
    {
        "icono": "gluten-free.svg",
        "nombre": "Comida sin gluten"
    },
    {
        "icono": "hairdryer.svg",
        "nombre": "Secador de pelo"
    },
    {
        "icono": "handicaped.svg",
        "nombre": "Adaptado para personas con movilidad reducida"
    },
    {
        "icono": "heating.svg",
        "nombre": "Calefacción"
    },
    {
        "icono": "interior-parking.svg",
        "nombre": "Aparcamiento interior"
    },
    {
        "icono": "languages.svg",
        "nombre": "Hablamos idiomas"
    },
    {
        "icono": "laundry.svg",
        "nombre": "Lavandería"
    },
    {
        "icono": "massage.svg",
        "nombre": "Masajes"
    },
    {
        "icono": "mini-bar.svg",
        "nombre": "Minibar"
    },
    {
        "icono": "multipurpose-hall.svg",
        "nombre": "Sala multiservicio"
    },
    {
        "icono": "music.svg",
        "nombre": "Música"
    },
    {
        "icono": "panoramic-view.svg",
        "nombre": "Vistas panorámicas"
    },
    {
        "icono": "reception.svg",
        "nombre": "Recepción"
    },
    {
        "icono": "phone.svg",
        "nombre": "Teléfono"
    },
    {
        "icono": "pool.svg",
        "nombre": "Piscina"
    },
    {
        "icono": "press-service.svg",
        "nombre": "Servicio de prensa"
    },
    {
        "icono": "radio.svg",
        "nombre": "Radio"
    },
    {
        "icono": "safe-box.svg",
        "nombre": "Caja fuerte"
    },
    {
        "icono": "shopping.svg",
        "nombre": "Situado en zona comercial"
    },
    {
        "icono": "solarium.svg",
        "nombre": "Solárium"
    },
    {
        "icono": "terrace.svg",
        "nombre": "Terraza"
    },
    {
        "icono": "towels.svg",
        "nombre": "Toallas"
    },
    {
        "icono": "transfer.svg",
        "nombre": "Traslado"
    },
    {
        "icono": "tv.svg",
        "nombre": "Tv"
    },
    {
        "icono": "venta-directa.svg",
        "nombre": "Venta directa"
    },
    {
        "icono": "wc-baby.svg",
        "nombre": "Baño para bebés"
    }
];

// Valoracions del disseny, per quan la web no té les de BedLoop actives.
export const OPINIONES = [
    {
        "texto": "Las vistas al rio fantásticas. El comedor con techos altos, musica baja y vistas al jardin.",
        "nombre": "Ramiro"
    },
    {
        "texto": "Desayuno completo y variado. El personal muy atento y familiar. Estancia agradable y las instalaciones están bien mantenidas y limpias.",
        "nombre": "Albert"
    },
    {
        "texto": "Ubicación muy buena, hotel muy bonito y bien conservado, cerca de todo, desayuno muy variado.",
        "nombre": "Bianca"
    },
    {
        "texto": "L’hotel està molt bé, molt ben situat i el personal molt atent!!! Mirarem de tornar a l’estiu i poder anar a la piscina que hi ha!",
        "nombre": "Carme"
    },
    {
        "texto": "Molt correcte tot.",
        "nombre": "Dolors"
    }
];

const TEXTOS = {
    "es": {
        "hero": [
            {
                "antetitulo": "Rodeado de naturaleza",
                "titulo": "Hotel con piscina, jardín y terraza en Camprodón"
            },
            {
                "antetitulo": "¡Descubre más de los servicios e instalaciones de nuestro hotel familiar!",
                "titulo": "Servicios del Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, en Camprodón",
            "enlace": "Descubre más sobre el Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Descubre nuestras instalaciones y servicios"
        },
        "ofertas": {
            "antetitulo": "Descubre las mejores ofertas en Camprodón",
            "titulo": "Ofertas del Hotel Camprodon",
            "texto": "<p>En el Hotel Camprodon ofrecemos paquetes y ofertas adaptadas a nuestros clientes. </p><p>No pierdas la oportunidad de disfrutar de una <strong>experiencia única en Camprodón al mejor precio</strong>. ¡Explora nuestras ofertas hoy mismo y reserva tu estancia con nosotros!</p>",
            "items": [
                {
                    "titulo": "Escapada de 2 Noches en Camprodon",
                    "texto": "Escapada de 2 noches en Camprodon los viernes y sábados desde el 7 de enero hasta el 28 de febrero (excepto el fin de semana del 13 de febrero). Incluye alojamiento, desayuno y acceso a instalaciones del hotel para disfrutar del Pirineo catalán en invierno.",
                    "alt": "Oferta 2 noches"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Descubre Camprodón",
            "titulo": "¿Qué hacer en Camprodón?",
            "texto": "<p>Ven a descubrir la naturaleza en el <strong>Pirineo de Girona</strong> y no te pierdas los pueblos de la <strong>Vall de Camprodón</strong>: Setcases, Llanars, Molló...</p><p>Disfruta del Pirineo más auténtico con el Hotel Camprodon.</p>",
            "items": [
                "Camprodón",
                "Actividades en Camprodón"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurante Hotel Camprodon",
            "texto": "En nuestro restaurante disfrutarás de una cocina tradicional catalana con productos de proximidad. Ubicado en una de nuestras salas nobles, en primavera y en verano, podrás comer en la terraza con vistas sobre el Pont Nou y el río Ter.",
            "alt": "Restaurante Hotel Camprodon",
            "enlace": "¡Descubre más!"
        }
    },
    "ca": {
        "hero": [
            {
                "antetitulo": "Envoltat de natura",
                "titulo": "Hotel amb piscina, jardí i terrassa a Camprodon"
            },
            {
                "antetitulo": "Descobriu més dels serveis i instal·lacions del nostre hotel familiar!",
                "titulo": "Serveis de l'Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, a Camprodon",
            "enlace": "Descobreix més sobre l'Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Descobreix les nostres instal·lacions i serveis"
        },
        "ofertas": {
            "antetitulo": "Descobreix les millors ofertes a Camprodon",
            "titulo": "Ofertes de l'Hotel Camprodon",
            "texto": "<p>A l'Hotel Camprodon oferim paquets i ofertes adaptades als nostres clients.</p><p>No perdeu l'oportunitat de gaudir d'una <strong>experiència única a Camprodon al millor preu</strong>. Explora les nostres ofertes avui mateix i reserva la teva estada amb nosaltres!</p>",
            "items": [
                {
                    "titulo": "Oferta 2 nits",
                    "texto": "",
                    "alt": "Oferta 2 nits"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Descobreix Camprodon",
            "titulo": "Què fer a Camprodon?",
            "texto": "<p>Vine a descobrir la natura al <strong>Pirineu de Girona</strong>, i no et perdis els pobles de la <strong>Vall de Camprodon</strong>: Setcases, Llanars, Molló...</p><p>Gaudeix del Pirineu més autèntic amb l’Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Activitats a Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurant Hotel Camprodon",
            "texto": "Al nostre restaurant gaudiràs d´una cuina tradicional catalana amb productes de proximitat. Ubicat en una de les nostres sales nobles, a la primavera ia l'estiu, podràs dinar a la terrassa amb vistes sobre el Pont Nou i el riu Ter.",
            "alt": "Restaurant Hotel Camprodon",
            "enlace": "Descobreix-ne més!"
        }
    },
    "en": {
        "hero": [
            {
                "antetitulo": "Surrounded by nature",
                "titulo": "Hotel with pool, garden and terrace in Camprodon"
            },
            {
                "antetitulo": "Discover more about the services and facilities of our family hotel!",
                "titulo": "Camprodon Hotel Services"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, in Camprodon",
            "enlace": "Find out more about the Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Discover our facilities and services"
        },
        "ofertas": {
            "antetitulo": "Discover the best offers in Camprodon",
            "titulo": "Hotel Camprodon Offers",
            "texto": "<p>At Hotel Camprodon we offer packages and offers tailored to our clients.</p><p>Do not miss the opportunity to enjoy a <strong>unique experience in Camprodon at the best price</strong>. Explore our offers today and book your stay with us!</p>",
            "items": [
                {
                    "titulo": "Offer 2 nights",
                    "texto": "",
                    "alt": "Offer 2 nights"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Discover Camprodon",
            "titulo": "What to do in Camprodon?",
            "texto": "<p>Come and discover the nature in the <strong>Pyrenees of Girona</strong>, and do not miss other towns on the <strong>Camprodon Valley</strong>: Setcases, Llanars, Molló...</p><p>Enjoy the Pyrenees at their most authentic at Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Activities in Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurant Hotel Camprodon",
            "texto": "In our restaurant you will enjoy traditional Catalan cuisine with local products. Located in one of our noble rooms, in spring and summer, you can eat on the terrace with views of the Pont Nou and the river Ter.",
            "alt": "Restaurant Hotel Camprodon",
            "enlace": "Find out more!"
        }
    },
    "fr": {
        "hero": [
            {
                "antetitulo": "Entouré par la nature",
                "titulo": "Hôtel avec piscine, jardin et terrasse à Camprodon"
            },
            {
                "antetitulo": "Découvrez en plus sur les services et installations de notre hôtel familial!",
                "titulo": "Services de l'Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, à Camprodon",
            "enlace": "En savoir plus sur l'Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Découvrez nos installations et services"
        },
        "ofertas": {
            "antetitulo": "Découvrez les meilleures offres à Camprodon",
            "titulo": "Offres Hotel Camprodon",
            "texto": "<p>À l'Hotel Camprodon, nous proposons des forfaits et des offres adaptés à nos clients.</p><p>Ne manquez pas l'occasion de vivre <strong>une expérience unique à Camprodon au meilleur prix</strong>. Découvrez nos offres dès aujourd'hui et réservez votre séjour avec nous!</p>",
            "items": [
                {
                    "titulo": "Offre 2 nuits",
                    "texto": "",
                    "alt": "Offre 2 nuits"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Découvrez Camprodon",
            "titulo": "Que faire à Camprodon?",
            "texto": "<p>Venez découvrir la nature des <strong>Pyrénées de Girona</strong>, sans manquer les villages de la <strong>vallée de Camprodon</strong>: Setcases, Llanars, Molló…</p><p>Profitez des Pyrénées les plus authentiques grâce à l’Hotel de Camprodon.</p>",
            "items": [
                "Camprodon",
                "Activités à Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurant Hôtel Camprodon",
            "texto": "Dans notre restaurant, vous dégusterez une cuisine traditionnelle catalane avec des produits locaux. Situé dans l'une de nos salles nobles, au printemps et en été, vous pourrez manger sur la terrasse avec vue sur le Pont Nou et le fleuve Ter.",
            "alt": "Restaurant Hôtel Camprodon",
            "enlace": "En savoir plus!"
        }
    },
    "it": {
        "hero": [
            {
                "antetitulo": "Immerso nella natura",
                "titulo": "Hotel con piscina, giardino e terrazza a Camprodon"
            },
            {
                "antetitulo": "Scopri di più sui servizi e sulle strutture del nostro hotel per famiglie!",
                "titulo": "Servizi dell'Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, a Camprodon",
            "enlace": "Scopri di più sull'Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Scopri le nostre strutture e i nostri servizi"
        },
        "ofertas": {
            "antetitulo": "Scopri le migliori offerte a Camprodon",
            "titulo": "Offerte dell'Hotel Camprodon",
            "texto": "<p>All'Hotel Camprodon offriamo pacchetti e offerte pensati per i nostri clienti.</p><p>Non perdere l'occasione di vivere un'<strong>esperienza unica a Camprodon al miglior prezzo</strong>. Scopri oggi stesso le nostre offerte e prenota il tuo soggiorno con noi!</p>",
            "items": [
                {
                    "titulo": "Fuga di 2 notti a Camprodon",
                    "texto": "Fuga di 2 notti a Camprodon il venerdì e il sabato dal 7 gennaio al 28 febbraio (escluso il fine settimana del 13 febbraio). Include alloggio, colazione e accesso alle strutture dell'hotel per goderti i Pirenei catalani in inverno.",
                    "alt": "Offerta 2 notti"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Scopri Camprodon",
            "titulo": "Cosa fare a Camprodon?",
            "texto": "<p>Vieni a scoprire la natura nei <strong>Pirenei di Girona</strong> e non perderti i paesi della <strong>Valle di Camprodon</strong>: Setcases, Llanars, Molló...</p><p>Goditi i Pirenei più autentici con l'Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Attività a Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Ristorante Hotel Camprodon",
            "texto": "Nel nostro ristorante potrai gustare una cucina tradizionale catalana con prodotti a km zero. Situato in una delle nostre sale nobili, in primavera e in estate potrai pranzare in terrazza con vista sul Pont Nou e sul fiume Ter.",
            "alt": "Ristorante Hotel Camprodon",
            "enlace": "Scopri di più!"
        }
    },
    "de": {
        "hero": [
            {
                "antetitulo": "Umgeben von Natur",
                "titulo": "Hotel mit Pool, Garten und Terrasse in Camprodon"
            },
            {
                "antetitulo": "Entdecken Sie die Leistungen und Einrichtungen unseres Familienhotels!",
                "titulo": "Leistungen des Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, in Camprodon",
            "enlace": "Mehr über das Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Entdecken Sie unsere Einrichtungen und Leistungen"
        },
        "ofertas": {
            "antetitulo": "Entdecken Sie die besten Angebote in Camprodon",
            "titulo": "Angebote des Hotel Camprodon",
            "texto": "<p>Im Hotel Camprodon bieten wir Pakete und Angebote, die auf unsere Gäste zugeschnitten sind.</p><p>Lassen Sie sich die Gelegenheit nicht entgehen, ein <strong>einzigartiges Erlebnis in Camprodon zum besten Preis</strong> zu genießen. Entdecken Sie noch heute unsere Angebote und buchen Sie Ihren Aufenthalt bei uns!</p>",
            "items": [
                {
                    "titulo": "2-Nächte-Auszeit in Camprodon",
                    "texto": "2-Nächte-Auszeit in Camprodon freitags und samstags vom 7. Januar bis 28. Februar (außer am Wochenende des 13. Februar). Inklusive Übernachtung, Frühstück und Nutzung der Hoteleinrichtungen, um die katalanischen Pyrenäen im Winter zu genießen.",
                    "alt": "Angebot 2 Nächte"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Entdecken Sie Camprodon",
            "titulo": "Was kann man in Camprodon unternehmen?",
            "texto": "<p>Entdecken Sie die Natur in den <strong>Pyrenäen von Girona</strong> und verpassen Sie nicht die Dörfer des <strong>Camprodon-Tals</strong>: Setcases, Llanars, Molló...</p><p>Genießen Sie die ursprünglichsten Pyrenäen mit dem Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Aktivitäten in Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurant Hotel Camprodon",
            "texto": "In unserem Restaurant genießen Sie traditionelle katalanische Küche mit regionalen Produkten. Es befindet sich in einem unserer historischen Säle; im Frühling und Sommer können Sie auf der Terrasse mit Blick auf die Pont Nou und den Fluss Ter speisen.",
            "alt": "Restaurant Hotel Camprodon",
            "enlace": "Mehr erfahren!"
        }
    },
    "pt": {
        "hero": [
            {
                "antetitulo": "Rodeado de natureza",
                "titulo": "Hotel com piscina, jardim e terraço em Camprodon"
            },
            {
                "antetitulo": "Descubra mais sobre os serviços e instalações do nosso hotel familiar!",
                "titulo": "Serviços do Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, em Camprodon",
            "enlace": "Saiba mais sobre o Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Descubra as nossas instalações e serviços"
        },
        "ofertas": {
            "antetitulo": "Descubra as melhores ofertas em Camprodon",
            "titulo": "Ofertas do Hotel Camprodon",
            "texto": "<p>No Hotel Camprodon oferecemos pacotes e ofertas adaptados aos nossos clientes.</p><p>Não perca a oportunidade de viver uma <strong>experiência única em Camprodon ao melhor preço</strong>. Explore as nossas ofertas hoje mesmo e reserve a sua estadia connosco!</p>",
            "items": [
                {
                    "titulo": "Escapadinha de 2 noites em Camprodon",
                    "texto": "Escapadinha de 2 noites em Camprodon às sextas e sábados de 7 de janeiro a 28 de fevereiro (exceto o fim de semana de 13 de fevereiro). Inclui alojamento, pequeno-almoço e acesso às instalações do hotel para desfrutar dos Pirenéus catalães no inverno.",
                    "alt": "Oferta 2 noites"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Descubra Camprodon",
            "titulo": "O que fazer em Camprodon?",
            "texto": "<p>Venha descobrir a natureza nos <strong>Pirenéus de Girona</strong> e não perca as aldeias do <strong>Vale de Camprodon</strong>: Setcases, Llanars, Molló...</p><p>Desfrute dos Pirenéus mais autênticos com o Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Atividades em Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurante Hotel Camprodon",
            "texto": "No nosso restaurante poderá desfrutar de uma cozinha tradicional catalã com produtos locais. Situado numa das nossas salas nobres, na primavera e no verão poderá almoçar no terraço com vista para a Pont Nou e o rio Ter.",
            "alt": "Restaurante Hotel Camprodon",
            "enlace": "Saiba mais!"
        }
    },
    "ru": {
        "hero": [
            {
                "antetitulo": "В окружении природы",
                "titulo": "Отель с бассейном, садом и террасой в Кампродоне"
            },
            {
                "antetitulo": "Узнайте больше об услугах и удобствах нашего семейного отеля!",
                "titulo": "Услуги отеля Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon в Кампродоне",
            "enlace": "Подробнее об отеле Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Наши удобства и услуги"
        },
        "ofertas": {
            "antetitulo": "Лучшие предложения в Кампродоне",
            "titulo": "Предложения отеля Hotel Camprodon",
            "texto": "<p>В Hotel Camprodon мы предлагаем пакеты и предложения, адаптированные для наших гостей.</p><p>Не упустите возможность получить <strong>уникальный опыт в Кампродоне по лучшей цене</strong>. Ознакомьтесь с нашими предложениями и забронируйте пребывание у нас!</p>",
            "items": [
                {
                    "titulo": "Отдых на 2 ночи в Кампродоне",
                    "texto": "Отдых на 2 ночи в Кампродоне по пятницам и субботам с 7 января по 28 февраля (кроме выходных 13 февраля). Включает проживание, завтрак и доступ к удобствам отеля, чтобы насладиться каталонскими Пиренеями зимой.",
                    "alt": "Предложение на 2 ночи"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Откройте для себя Кампродон",
            "titulo": "Чем заняться в Кампродоне?",
            "texto": "<p>Откройте для себя природу <strong>Пиренеев Жироны</strong> и посетите деревни <strong>долины Кампродон</strong>: Сеткасес, Льянарс, Мольо...</p><p>Наслаждайтесь самыми настоящими Пиренеями вместе с Hotel Camprodon.</p>",
            "items": [
                "Кампродон",
                "Чем заняться в Кампродоне"
            ]
        },
        "restaurante": {
            "antetitulo": "Ресторан Hotel Camprodon",
            "texto": "В нашем ресторане вас ждёт традиционная каталонская кухня из местных продуктов. Он расположен в одном из наших парадных залов; весной и летом можно пообедать на террасе с видом на мост Понт-Ноу и реку Тер.",
            "alt": "Ресторан Hotel Camprodon",
            "enlace": "Узнать больше!"
        }
    },
    "sv": {
        "hero": [
            {
                "antetitulo": "Omgiven av natur",
                "titulo": "Hotell med pool, trädgård och terrass i Camprodon"
            },
            {
                "antetitulo": "Upptäck mer om tjänsterna och faciliteterna på vårt familjehotell!",
                "titulo": "Tjänster på Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, i Camprodon",
            "enlace": "Läs mer om Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Upptäck våra faciliteter och tjänster"
        },
        "ofertas": {
            "antetitulo": "Upptäck de bästa erbjudandena i Camprodon",
            "titulo": "Erbjudanden på Hotel Camprodon",
            "texto": "<p>På Hotel Camprodon erbjuder vi paket och erbjudanden anpassade efter våra gäster.</p><p>Missa inte chansen att få en <strong>unik upplevelse i Camprodon till bästa pris</strong>. Utforska våra erbjudanden redan idag och boka din vistelse hos oss!</p>",
            "items": [
                {
                    "titulo": "Miniresa 2 nätter i Camprodon",
                    "texto": "Miniresa 2 nätter i Camprodon fredagar och lördagar från 7 januari till 28 februari (utom helgen den 13 februari). Inkluderar boende, frukost och tillgång till hotellets faciliteter för att njuta av de katalanska Pyrenéerna på vintern.",
                    "alt": "Erbjudande 2 nätter"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Upptäck Camprodon",
            "titulo": "Vad kan man göra i Camprodon?",
            "texto": "<p>Kom och upptäck naturen i <strong>Gironas Pyrenéer</strong> och missa inte byarna i <strong>Camprodondalen</strong>: Setcases, Llanars, Molló...</p><p>Njut av de mest autentiska Pyrenéerna med Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Aktiviteter i Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurang Hotel Camprodon",
            "texto": "I vår restaurang kan du njuta av traditionell katalansk mat med lokala råvaror. Den ligger i en av våra historiska salonger, och på våren och sommaren kan du äta på terrassen med utsikt över Pont Nou och floden Ter.",
            "alt": "Restaurang Hotel Camprodon",
            "enlace": "Läs mer!"
        }
    },
    "cs": {
        "hero": [
            {
                "antetitulo": "Obklopen přírodou",
                "titulo": "Hotel s bazénem, zahradou a terasou v Camprodonu"
            },
            {
                "antetitulo": "Objevte služby a vybavení našeho rodinného hotelu!",
                "titulo": "Služby hotelu Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon v Camprodonu",
            "enlace": "Více o hotelu Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Objevte naše vybavení a služby"
        },
        "ofertas": {
            "antetitulo": "Objevte nejlepší nabídky v Camprodonu",
            "titulo": "Nabídky hotelu Hotel Camprodon",
            "texto": "<p>V hotelu Hotel Camprodon nabízíme balíčky a nabídky přizpůsobené našim hostům.</p><p>Nenechte si ujít příležitost zažít <strong>jedinečný zážitek v Camprodonu za nejlepší cenu</strong>. Prohlédněte si naše nabídky ještě dnes a rezervujte si u nás pobyt!</p>",
            "items": [
                {
                    "titulo": "Pobyt na 2 noci v Camprodonu",
                    "texto": "Pobyt na 2 noci v Camprodonu v pátek a sobotu od 7. ledna do 28. února (kromě víkendu 13. února). Zahrnuje ubytování, snídani a přístup k vybavení hotelu, abyste si užili katalánské Pyreneje v zimě.",
                    "alt": "Nabídka na 2 noci"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Objevte Camprodon",
            "titulo": "Co dělat v Camprodonu?",
            "texto": "<p>Přijeďte objevit přírodu <strong>Pyrenejí v Gironě</strong> a nenechte si ujít vesnice <strong>údolí Camprodon</strong>: Setcases, Llanars, Molló...</p><p>Užijte si nejautentičtější Pyreneje s hotelem Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Aktivity v Camprodonu"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurace Hotel Camprodon",
            "texto": "V naší restauraci ochutnáte tradiční katalánskou kuchyni z místních surovin. Nachází se v jednom z našich historických sálů; na jaře a v létě můžete obědvat na terase s výhledem na most Pont Nou a řeku Ter.",
            "alt": "Restaurace Hotel Camprodon",
            "enlace": "Zjistit více!"
        }
    },
    "nl": {
        "hero": [
            {
                "antetitulo": "Omringd door natuur",
                "titulo": "Hotel met zwembad, tuin en terras in Camprodon"
            },
            {
                "antetitulo": "Ontdek meer over de diensten en faciliteiten van ons familiehotel!",
                "titulo": "Diensten van Hotel Camprodon"
            }
        ],
        "presentacion": {
            "alt": "Hotel Camprodon, in Camprodon",
            "enlace": "Meer over Hotel Camprodon"
        },
        "servicios": {
            "antetitulo": "Ontdek onze faciliteiten en diensten"
        },
        "ofertas": {
            "antetitulo": "Ontdek de beste aanbiedingen in Camprodon",
            "titulo": "Aanbiedingen van Hotel Camprodon",
            "texto": "<p>In Hotel Camprodon bieden we arrangementen en aanbiedingen op maat van onze gasten.</p><p>Mis de kans niet om een <strong>unieke ervaring in Camprodon tegen de beste prijs</strong> te beleven. Bekijk vandaag nog onze aanbiedingen en boek je verblijf bij ons!</p>",
            "items": [
                {
                    "titulo": "Uitje van 2 nachten in Camprodon",
                    "texto": "Uitje van 2 nachten in Camprodon op vrijdag en zaterdag van 7 januari tot 28 februari (behalve het weekend van 13 februari). Inclusief overnachting, ontbijt en toegang tot de hotelfaciliteiten om in de winter van de Catalaanse Pyreneeën te genieten.",
                    "alt": "Aanbieding 2 nachten"
                }
            ]
        },
        "entorno": {
            "antetitulo": "Ontdek Camprodon",
            "titulo": "Wat te doen in Camprodon?",
            "texto": "<p>Ontdek de natuur in de <strong>Pyreneeën van Girona</strong> en mis de dorpen van de <strong>Camprodonvallei</strong> niet: Setcases, Llanars, Molló...</p><p>Geniet van de meest authentieke Pyreneeën met Hotel Camprodon.</p>",
            "items": [
                "Camprodon",
                "Activiteiten in Camprodon"
            ]
        },
        "restaurante": {
            "antetitulo": "Restaurant Hotel Camprodon",
            "texto": "In ons restaurant geniet je van de traditionele Catalaanse keuken met lokale producten. Het bevindt zich in een van onze historische zalen; in de lente en zomer kun je op het terras eten met uitzicht op de Pont Nou en de rivier de Ter.",
            "alt": "Restaurant Hotel Camprodon",
            "enlace": "Meer ontdekken!"
        }
    }
};

// Textos propis de l'hotel en l'idioma de la web (el castellà si no n'hi ha).
const textosCamprodon = (lang) => TEXTOS[(lang || "es").toString().toLowerCase()] || TEXTOS.es;

export default textosCamprodon;
